import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';

import { isSpecialtyAlbum } from '../../../../../../util/album';
import {
  getWebGalleryEntityPath,
  getWebGalleryFacesPath,
  getWebGalleryVideosPath,
} from '../../../../utilities/web-galleries';
import Button from '../../../../../../components/global/Button';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
  }),
  albumPhotoGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const MATCHES_PATHS = {
  PHOTOS: 'PHOTOS',
  VIDEOS: 'VIDEOS',
  FACES: 'FACES',
};

const WebGalleryRouteSelector = ({ album, albumPhotoGroup }) => {
  const location = useLocation();

  const matchesPath = (() => {
    if (location?.pathname.includes('videos')) {
      return MATCHES_PATHS.VIDEOS;
    }
    if (location?.pathname.includes('faces')) {
      return MATCHES_PATHS.FACES;
    }

    return MATCHES_PATHS.PHOTOS;
  })();

  const shouldRenderSelector = !isSpecialtyAlbum(album);
  const shouldRenderVideoTab = album?.videos?.total > 0;
  const shouldRenderFacesTab =
    album?.root_album_folder?.joins_enabled &&
    album?.joins_enabled &&
    album?.root_album_folder?.id &&
    !isSpecialtyAlbum(album);

  return (
    <div className="matches-set-selector-container">
      {shouldRenderSelector && (
        <Fragment>
          <Button
            btnStyle="reset"
            className={classNames({
              'matches-set-selector': true,
              'is-active': matchesPath === MATCHES_PATHS.PHOTOS,
            })}
            to={getWebGalleryEntityPath(albumPhotoGroup || album)}
          >
            Photos
          </Button>
          {shouldRenderVideoTab && (
            <Button
              btnStyle="reset"
              className={classNames({
                'matches-set-selector': true,
                'is-active': matchesPath === MATCHES_PATHS.VIDEOS,
              })}
              to={getWebGalleryVideosPath(albumPhotoGroup || album)}
            >
              Videos
            </Button>
          )}
          {shouldRenderFacesTab && (
            <Button
              btnStyle="reset"
              className={classNames({
                'matches-set-selector': true,
                'is-active': matchesPath === MATCHES_PATHS.FACES,
              })}
              to={getWebGalleryFacesPath(albumPhotoGroup || album)}
            >
              People
            </Button>
          )}
        </Fragment>
      )}
    </div>
  );
};

WebGalleryRouteSelector.propTypes = propTypes;

export default WebGalleryRouteSelector;
